import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useLearningType } from '@/store/v2/learnings/useLearningType';
import { RLearningType } from '@/store/v2';
import { Course } from '@/features/course/learner/pages/Course';
import { Survey } from '@/features/course/learner/pages/Survey';
import { PracticalAssessment } from '@/features/course/learner/pages/PracticalAssessment';
import { Learning as LegacyLearning } from '@/pages/learning/Learning/Learning';
import { LoadingHero } from '@/component/LoadingHero';
import { LayoutWrapper } from '@/component/App/component/LayoutWrapper/LayoutWrapper';
import { LiveEvent } from '@/pages/LiveEvent';
import { ROUTE_PATH } from '@/constants/routePaths';

export const LearningRouter = (): React.ReactElement => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const parsedId = id ? parseInt(id) : NaN;

  const { type, loading, error } = useLearningType({ id: parsedId });
  if (!parsedId) {
    navigate(ROUTE_PATH.NOT_FOUND);
    return <></>;
  }

  if (error) {
    navigate(ROUTE_PATH.NOT_FOUND);
    return <>Error</>;
  }

  if (loading) return <LoadingHero />;

  if (type === RLearningType.Course) return <Course />;
  if (type === RLearningType.Survey) return <Survey />;
  if (type === RLearningType.PracticalAssessment) return <PracticalAssessment />;
  if (type === RLearningType.LiveEvent)
    return (
      <LayoutWrapper>
        <LiveEvent />
      </LayoutWrapper>
    );

  return (
    <LayoutWrapper>
      <LegacyLearning />
    </LayoutWrapper>
  );
};
